<template>
  <HeadlessSearch>
    <template #default="{ userInput, listeners }">
      <input
        ref="inputRef"
        class="help-center-search-input__input"
        :value="userInput"
        placeholder="Search"
        v-on="listeners"
      />
    </template>
  </HeadlessSearch>
</template>

<script setup>
import { ref, toRef, watch } from 'vue'
import HeadlessSearch from 'gleam-shared/components/HeadlessSearch'

const props = defineProps({
  focus: Boolean
})

const inputRef = ref(null)
const focusRef = toRef(props, 'focus')

watch([focusRef, inputRef], ([focus, input]) => {
  if (focus && input) {
    input.focus()
  }
}, { flush: 'post' })
</script>

<style lang="scss">
@import 'help-center/mixins';

.help-center-search-input {
  &__input {
    @include reset-input;
    @include help-center-focus-ring;
    @include help-center-font(16);
    color: var(--help-center-accent);
    display: flex;
    width: 100%;

    &::placeholder {
      color: var(--help-center-muted);
    }
  }
}
</style>
